export default "__VITE_ASSET__CpV0waXr__"